export default {"src":"/_next/static/media/paragraph.53b2177a.svg","height":40,"width":40};